module.exports = __webpack_public_path__ + "img/chris (17).aad234eb.jpg";